<app-lms-modal-frame [title]="'Area Details'" [pageHeadWidth]="300">
  <div modal-body>
    <div class="container-fluid">
      <div class="row center-screen">
        <div class="container-sm center-container">
          <form [formGroup]="areaForm">
            <table class="table table-striped table-hover table-sm">
              <caption>Update area name</caption>
              <tbody class="field-4column-label">
                <tr>
                  <td>Area</td>
                  <td>
                    <input formControlName="areaCtrl" lmsNoSpecials toUppercase type="text" required>
                    <div *ngIf="areaCtrl!.errors?.required && submitted" class="error-label">
                      Area is required
                    </div>
                    <div *ngIf="areaCtrl?.errors?.NoSpecials">
                      <small class="text-danger">
                        Special characters are not allowed.
                      </small>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div modal-actions class="lms-action-bar">
    <button class="btn btn-primary btn-sm" mdbRipple (click)="dialogRef.close()"> Close
    </button>
    <button class="btn btn-primary btn-sm" mdbRipple (click)="saveArea()">Save</button>
  </div>
</app-lms-modal-frame>
